
import React, { useEffect, useState } from 'react';
import { Crown, Sparkles, Users } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

const BonusPromoCard: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [availableSpots] = useState(Math.floor(Math.random() * 31) + 20);
  const { user } = useAuth();

  useEffect(() => {
    // Don't show the promo if user is signed in
    if (user) {
      setIsVisible(false);
      return;
    }
    
    // Show the promo card if the user came from promo or based on some conditions
    const fromPromo = localStorage.getItem('fromBonusPromo');
    if (fromPromo) {
      setIsVisible(true);
      // Clear it after use
      localStorage.removeItem('fromBonusPromo');
    } else {
      // Also randomly show the promotion to some users (50% chance)
      const shouldShow = Math.random() > 0.5;
      setIsVisible(shouldShow);
    }
  }, [user]);

  if (!isVisible) return null;

  return (
    <div className="w-full mb-6 bg-[#9E7C47]/10 border border-[#9E7C47]/30 rounded-xl p-4 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute -top-8 -right-8 w-16 h-16 bg-[#9E7C47]/30 rounded-full blur-lg opacity-70" />
      <div className="absolute -bottom-8 -left-8 w-16 h-16 bg-[#9E7C47]/20 rounded-full blur-lg opacity-70" />
      
      <div className="flex items-center gap-3 relative z-10">
        <div className="w-12 h-12 rounded-full bg-[#9E7C47]/20 flex items-center justify-center shrink-0">
          <Crown className="h-6 w-6 text-[#9E7C47]" />
        </div>
        
        <div className="flex-1">
          <div className="flex items-center">
            <h3 className="text-lg font-bold mb-1 text-white mr-2">Exclusive Early Access</h3>
            <span className="bg-[#9E7C47]/20 text-[#9E7C47] text-xs px-2 py-0.5 rounded-full">
              <Sparkles className="inline-block h-3 w-3 mr-1" />
              Invite Only
            </span>
          </div>
          
          <div className="flex items-center text-xs text-white/70 mb-1.5">
            <Users className="h-3 w-3 text-[#9E7C47] mr-1" />
            <span>Limited beta access · Select investors only</span>
          </div>
          
          <div className="w-full bg-white/10 rounded-full h-1.5">
            <div className="bg-[#9E7C47] h-1.5 rounded-full transition-all duration-1000 ease-out w-3/4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BonusPromoCard;
